import { t } from "i18next";
import { useEffect, useState } from "react";
import { emptyTeam, Team } from "../../../interfaces/team";
import { getTeamSingle } from "../../../services/team";
import { LoadingSpinner } from "../../general/loading-spinner";
import { Link, useParams } from "react-router-dom";
import { Col, Form, Row } from "react-bootstrap";
import { getSeasonCurrent, getSeasonOptions } from "../../../services/season";
import { emptySeason, Season } from "../../../interfaces/season";
import { getAthlete } from "../../../services/athlete";
import athletesGreenIcon from "../../../assets/images/athletes.svg";
import { Athlete } from "../../../interfaces/athlete";
import moment from 'moment';

export function TeamView() {
    const params: any = useParams();

    const [loaded, setLoaded] = useState(false);
    const [team, setTeam] = useState<Team>(emptyTeam);
    const [athletes, setAthletes] = useState<any[]>([]);
    const [seasonOptions, setSeasonOptions] = useState<Season[]>([]);
    const [defaultSeason, setDefaultSeason] = useState<Season>(emptySeason);
    const [refreshed, setRefreshed] = useState(false);

    useEffect(() => {
        Promise.all([
            getTeamSingle(params.id),
            getSeasonCurrent(),
            getSeasonOptions()
        ]).then(response => {
            setTeam(response[0].data);
            setDefaultSeason(response[1].data);
            setSeasonOptions(response[2].data);
            if (response[0].data.id !== undefined && response[1].data.id !== undefined) {
                getAthlete('', '', response[0].data.id, response[2].data.id)
                    .then(responseAthlete => {
                        setAthletes(responseAthlete.data);
                        setLoaded(true);
                        setRefreshed(true);
                    });
            } else {
                setLoaded(true);
                setRefreshed(true);
            }
        });
    }, []);

    const handleSeasonChange = (event: any) => {
        console.log(team);
        setRefreshed(false);
        const index = seasonOptions.findIndex((s: Season) => s.id == event.currentTarget.value);
        if (index !== -1) {
            getAthlete('', '', team.id.toString(), seasonOptions[index].id.toString())
                .then(response => {
                    setAthletes(response.data);
                    setRefreshed(true);
                });
        }
    }
    
    return (
        <div className="team-view-container"> 
            <div className="inner">
                { !loaded && 
                    <LoadingSpinner />
                }
                { loaded && 
                    <div className="team-content">
                        <h1>{ team.name }</h1>
                        <Row>
                            <Col xs={12} md={6} lg={4}>
                                <div className="content-data content-box">
                                    <div className="content-item">
                                        <span className="label">{ t('club') }</span>: { team.club_name }
                                    </div>
                                    <div className="content-item">
                                        <span className="label">{ t('modality') }</span>: { team.modality_name }
                                    </div>
                                    <div className="content-item">
                                        <span className="label">{ t('category') }</span>: { team.category_name }
                                    </div>
                                </div>
                            </Col>
                            <Col xs={12} md={6} lg={8}>
                                <div className="block block-athletes-mini">
                                    <div className="block-inner">
                                        <h3 className="block-title">
                                            <img src={ athletesGreenIcon } alt={ t("athletes")} />
                                            { t("athletes") }
                                        </h3>
                                        <div className="block-content">
                                            { !loaded && 
                                                <LoadingSpinner />
                                            }
                                            { loaded &&
                                                <div className="block-content-inner">
                                                    <div className="block-content-filters">
                                                        <Form.Group controlId="season_id">
                                                            <Form.Select aria-label={ t("season") } name="season" defaultValue={ defaultSeason.id }
                                                                onChange={ handleSeasonChange }>
                                                                { seasonOptions.map((s: Season) => {
                                                                    return <option key={ 'season-' + s.name } value={ s.id }>{ t("season") + ' ' + s.name }</option>;
                                                                })}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </div>
                                                    <div className="block-content-data">
                                                        { !refreshed && <LoadingSpinner /> }
                                                        { refreshed &&
                                                            athletes.slice(0, 10).map((a: Athlete) => {
                                                                return (<div key={ 'athlete-' + a.id } className="athlete-tile">
                                                                        <div className="icon">
                                                                            { a.avatar.length > 0 &&
                                                                                <img src={ a.avatar[0].src } alt={ a.avatar[0].name } />
                                                                            }
                                                                        </div>
                                                                        <div className="title">
                                                                            <Link to={ '/athletes/' + a.id + '/view' }  title={ a.name }>
                                                                                { a.name }
                                                                            </Link>
                                                                            <div className="years">
                                                                                { moment(new Date()).diff(a.birthdate, 'years') + ' ' + t("years").toLowerCase() } 
                                                                            </div>
                                                                        </div>
                                                                    </div>)
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>  
                    </div>
                }
            </div>
        </div>
    );
}